<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';
import BaseBubble from 'next/message/bubbles/Base.vue';

const { contentAttributes } = useMessageContext();
const { t } = useI18n();

const translationMessage = computed(() => {
  switch (contentAttributes.value.type) {
    case 'request_to_share_info':
      return t('MESSAGES.ZALO.REQUEST_TO_SHARE_INFO');
    default:
      return t('MESSAGES.INTEGRATIONS.DEFAULT');
  }
});
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="text">
    <div class="gap-3 flex flex-col">
      {{ translationMessage }}
    </div>
  </BaseBubble>
</template>
